import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Sparkle, ArrowRight, X } from "@phosphor-icons/react";

const KEY = "vv_ann_dismissed";

export default function AnnouncementBanner() {
  const [ann, setAnn] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    let live = true;
    api
      .get("/announcement")
      .then(({ data }) => {
        if (!live || !data?.active) return;
        if (localStorage.getItem(KEY) === data.id) return;
        setAnn(data);
      })
      .catch(() => {});
    return () => {
      live = false;
    };
  }, []);

  if (!ann) return null;

  const dismiss = () => {
    localStorage.setItem(KEY, ann.id);
    setAnn(null);
  };
  const go = () => {
    if (!ann.cta_link) return;
    if (ann.cta_link.startsWith("/")) navigate(ann.cta_link);
    else window.location.href = ann.cta_link;
  };

  return (
    <div data-testid="announcement-banner" className="bg-[#B47A3C] text-white">
      <div className="max-w-6xl mx-auto px-6 py-2.5 pr-12 flex items-center justify-center gap-3 text-center relative">
        <Sparkle size={16} weight="fill" className="shrink-0" />
        <p className="text-sm sm:text-[15px] font-semibold leading-snug">{ann.message}</p>
        {ann.cta_label && (
          <button
            onClick={go}
            data-testid="announcement-cta"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-bold underline underline-offset-2 hover:no-underline whitespace-nowrap"
          >
            {ann.cta_label} <ArrowRight size={14} weight="bold" />
          </button>
        )}
        <button
          onClick={dismiss}
          data-testid="announcement-dismiss"
          title="Dismiss"
          className="absolute right-4 top-1/2 -translate-y-1/2 hover:opacity-70 transition-opacity"
        >
          <X size={16} weight="bold" />
        </button>
      </div>
    </div>
  );
}
